<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-11">The</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-12">Power</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-11">of</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-12">Patience</span></p>
<p class="Basic-Paragraph ParaOverride-15"><span class="CharOverride-13"> </span></p>
<p class="subtxt">How This Old-Fashioned Virtue</p>
<p class="subtxt">Can Improve Your Life</p>
<p class="Body-Text ParaOverride-16"> </p>
<p class="author">M.J. Ryan</p>
<p class="Body-Text ParaOverride-17"><img alt="" src="image/cplogo_titlepage.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ThePowerOfPatience-1.vue?0e3f7684